import { render } from "./tab-content-item.vue?vue&type=template&id=2efc1375"
import script from "./tab-content-item.vue?vue&type=script&lang=js"
export * from "./tab-content-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__